"use strict";
/* eslint-disable */
/**
 * This file was automatically generated by scripts/manifest/index-ts.mustache.
 * DO NOT MODIFY IT BY HAND. Instead, modify scripts/manifest/index-ts.mustache,
 * and run node ./scripts/manifest/generateFormatTypes.js to regenerate this file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBuildManifest = exports.deserializeBuildManifest = exports.migrateBuildManifest = exports.latestBuildManifestFormat = exports.BuildManifestFormats = void 0;
var BuildManifestFormats;
(function (BuildManifestFormats) {
    BuildManifestFormats["0.0.1-prealpha.1"] = "0.0.1-prealpha.1";
    BuildManifestFormats["0.0.1-prealpha.2"] = "0.0.1-prealpha.2";
})(BuildManifestFormats = exports.BuildManifestFormats || (exports.BuildManifestFormats = {}));
exports.latestBuildManifestFormat = BuildManifestFormats["0.0.1-prealpha.2"];
var migrate_1 = require("./migrate");
Object.defineProperty(exports, "migrateBuildManifest", { enumerable: true, get: function () { return migrate_1.migrateBuildManifest; } });
var deserialize_1 = require("./deserialize");
Object.defineProperty(exports, "deserializeBuildManifest", { enumerable: true, get: function () { return deserialize_1.deserializeBuildManifest; } });
var validate_1 = require("./validate");
Object.defineProperty(exports, "validateBuildManifest", { enumerable: true, get: function () { return validate_1.validateBuildManifest; } });
//# sourceMappingURL=index.js.map